<template>
  <nav class="analysis-menu">
    <ul class="analysis-menu__list">
      <li
        v-for="({ link, text }, index) in list"
        :class="[currentClass(link), link ? 'menu-list' : 'menu-label']"
        :key="index"
      >
        <a :href="`/analysis/${link}/`">{{ text }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
/**
 * 分析画面左カラムメニュー
 */
export default {
  name: 'AnalysisNavigation',
  components: {
    /**  */
  },
  props: {
    /** 表示中のメニュー */
    current: String,
  },
  data() {
    return {
      list: [
        { link: 'dashboard', text: 'ダッシュボード' },
        { link: '', text: '集計' },
        { link: 'customer', text: '人数' },
        { link: 'route', text: '予約経路' },
        { link: 'call', text: '電話自動受付予約（IVR）' },
        { link: 'coursemenu', text: 'コース' },
        { link: 'tag', text: '予約タグ' },
        { link: 'cancel', text: 'キャンセル' },
        { link: '', text: '目標' },
        { link: 'target', text: '目標設定' },
        { link: 'progress', text: '達成状況' },
      ],
    }
  },
  methods: {
    currentClass(page) {
      return { current: this.current.startsWith(`/analysis/${page}`) }
    },
  },
}
</script>

<style lang="postcss" scoped>
.analysis-menu {
  background-color: var(--white);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  width: 184px;

  .app & {
    height: calc(100vh - 48px - 16px);
  }
}

.analysis-menu__list {
  list-style: none;
  width: 184px;

  li {
    box-sizing: border-box;
    font-size: 13px;
    position: relative;

    &:not(:first-of-type)::after {
      background-color: var(--border-color);
      content: '';
      display: block;
      height: 1px;
      left: 16px;
      position: absolute;
      top: 0;
      width: calc(100% - 32px);
    }

    a {
      align-items: center;
      box-sizing: border-box;
      color: var(--text-color);
      display: flex;
      text-decoration: none;
    }

    &:first-of-type a {
      height: 56px;
    }

    &.menu-list {
      &:last-child {
        border-bottom: 1px solid var(--border-color);
      }

      &.current {
        background-color: var(--very-light-yellow);
      }

      a {
        line-height: 26px;
        min-height: 48px;
        padding: 10px 16px;
      }
    }

    &.menu-label {
      align-items: center;
      background-color: var(--very-light-gray-2);
      color: var(--very-dark-gray-2);
      display: flex;
      font-size: 13px;
      font-weight: bold;
      height: 32px;
      line-height: 33px;
      padding: 0 16px;
      text-align: center;

      a {
        display: inline-block;
        pointer-events: none;
      }

      &::after,
      & + li::after {
        display: none;
      }
    }
  }
}
</style>
